import type { CanvasSummary } from '@/api/types';
import { cx } from '@/lib/cx';
import { useT } from '@/i18n/LocaleProvider';
import styles from './VideoGrid.module.css';

interface Props {
  dir: 'left' | 'right';
  canvases: CanvasSummary[];
  /** Канвасы, на которых видео уже есть. */
  presentIds: readonly number[];
  onPick: (canvasId: number, alreadyPresent: boolean) => void;
  onNew: () => void;
}

const shortName = (name: string) => (name.length > 16 ? `${name.slice(0, 15).trim()}…` : name);

/** Флайаут «Add to canvas» у карточки: список канвасов с обложками и состоянием add / added. */
export function CanvasFlyout({ dir, canvases, presentIds, onPick, onNew }: Props) {
  const t = useT();
  return (
    <div className={styles.flyAnchor} data-dir={dir}>
      <div className={styles.fly} role="menu" aria-label={t('catalog.addToCanvas')}>
        <div className={styles.flyBar} aria-hidden="true" />
        <p className={styles.flyEyebrow}>{t('catalog.addToCanvas')}</p>
        {canvases.map((canvas) => {
          const on = presentIds.includes(canvas.id);
          return (
            <button
              key={canvas.id}
              type="button"
              role="menuitem"
              title={canvas.name}
              className={styles.flyItem}
              onClick={(e) => {
                e.stopPropagation();
                onPick(canvas.id, on);
              }}
            >
              {canvas.cover_url ? (
                <img src={canvas.cover_url} alt="" className={styles.flyCover} />
              ) : (
                <span className={styles.flyCover} />
              )}
              <span className={styles.flyName} data-clarity-mask="true">
                {shortName(canvas.name)}
              </span>
              <span className={cx(styles.flyState, on && styles.flyStateOn)}>
                {on ? t('picker.added') : t('picker.add')}
              </span>
            </button>
          );
        })}
        <button
          type="button"
          role="menuitem"
          className={styles.flyNew}
          onClick={(e) => {
            e.stopPropagation();
            onNew();
          }}
        >
          {t('catalog.newCanvasEllipsis')}
        </button>
      </div>
    </div>
  );
}
